/**
 * news_session.js — small helper for stable session IDs used by the
 * conversion-articles experiment (impression + scroll-50 + cta-click tracking).
 *
 * The session ID persists in localStorage so revisits in the same browser
 * always read the same variant (idempotent impressions).
 */
const KEY = 'news_session_id';

const uuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const getNewsSessionId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(KEY, id);
  }
  return id;
};
